/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

/**
 * PublicBranding renders a minimal Hero toolbar for use on public routes
 * (e.g. logged-out, login-failed) where the full authenticated navigation
 * is not available.
 */
export default class PublicBranding extends Component {}
